import { apiRequest } from '@glow/shared/lib/http';
import { useQuery } from '@tanstack/vue-query';
import type { Service } from '../types';
import { serviceKeys } from './keys';

export function getPoppularServices() {
  return apiRequest<Service[]>('get', '/services/popular');
}

export function useGetPopularServices(enabled: MaybeRef<boolean> = true) {
  return useQuery(serviceKeys.popularList(), () => getPoppularServices(), {
    enabled,
  });
}
